import {Icon, LabelSmallRegular, TextSmallMedium} from '@hm/fundamental'
import {mdiCached, mdiTimerSand, mdiTimerSandComplete, mdiMinusCircleOutline} from '@mdi/js'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {ReactComponent as Closed} from '../../../../Assets/paymentIcons/closed.svg'
import {Invoice, InvoiceStatus as InvoiceStatusType} from '../Invoice.types'

export const isPaymentPending = (invoice: Invoice) =>
  !!(invoice.isFinanceAccountingInvoice
    ? invoice.isPaymentPending
    : invoice.lineItems.find((item) => item.isPaymentPending))

type InvoiceStatusProps = {
  invoice: Invoice
}

export const InvoiceStatus = ({invoice}: InvoiceStatusProps) => {
  const {t} = useTranslation()

  if (
    (invoice.status === InvoiceStatusType.open ||
      invoice.status === InvoiceStatusType.partiallyPaid) &&
    isPaymentPending(invoice)
  ) {
    return (
      <div className="flex flex-col items-start gap-1">
        <div className="flex items-center gap-1 bg-[#8383831A] px-2 py-1">
          <Icon path={mdiCached} customSize="12px" />
          <TextSmallMedium>{t(`invoice.statuses.${invoice.status}`)}</TextSmallMedium>
        </div>
        <LabelSmallRegular>{t('invoice.statuses.processing.title')}</LabelSmallRegular>
      </div>
    )
  }

  switch (invoice.status) {
    case InvoiceStatusType.open:
      return (
        <div className="flex items-center gap-1 bg-[#0184441A] px-2 py-1 rounded">
          <Icon path={mdiTimerSandComplete} color="#018444" customSize="12px" />
          <TextSmallMedium className="text-[#018444]">
            {t(`invoice.statuses.${invoice.status}`)}
          </TextSmallMedium>
        </div>
      )
    case InvoiceStatusType.cancelled:
      return (
        <div className="flex items-center gap-1 bg-[#EC3D361A] px-2 py-1 rounded">
          <Icon path={mdiMinusCircleOutline} color="#EC3D36" customSize="12px" />
          <TextSmallMedium className="text-[#EC3D36]">
            {t(`invoice.statuses.${invoice.status}`)}
          </TextSmallMedium>
        </div>
      )
    case InvoiceStatusType.partiallyPaid:
      return (
        <div className="flex items-center gap-1 bg-[#BAB3081A] px-2 py-1 rounded">
          <Icon path={mdiTimerSand} color="#BAB308" customSize="12px" />
          <TextSmallMedium className="text-[#BAB308]">
            {t(`invoice.statuses.${invoice.status}`)}
          </TextSmallMedium>
        </div>
      )
    case InvoiceStatusType.closed:
      return (
        <div className="flex items-center gap-1 bg-[#A0A0A01A] px-2 py-1 rounded">
          <Closed className="h-3 w-3" />
          <TextSmallMedium className="text-[#A0A0A0]">
            {t(`invoice.statuses.${invoice.status}`)}
          </TextSmallMedium>
        </div>
      )
    default:
      return null
  }
}
